var map = {
	"./es/announcements/list.json": [
		378,
		4
	],
	"./es/common.json": [
		379,
		5
	],
	"./es/degree-processes/documents.json": [
		380,
		6
	],
	"./es/degree-processes/main.json": [
		381,
		7
	],
	"./es/petitions.json": [
		382,
		8
	],
	"./es/survey.json": [
		383,
		9
	],
	"./es/terms.json": [
		384,
		10
	],
	"./es/translation.json": [
		385,
		11
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 267;
module.exports = webpackAsyncContext;